export default __webpack_public_path__ + "static/LeituraSansTwo-MediumItalic-d4f4a883fb688887d8dda36ecfbef0ac.woff2";